import { Grid } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {
  BtnBaseButton,
  BtnClear,
  BtnExportExcel,
  BtnSearch,
} from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { useState, useEffect } from "react";
import { FnAxios } from "utilities/utilities";
import MultiSelectFormLimit from "components/Input/Select/MultipleSelectItemLimit";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { BsFileEarmarkExcel } from "react-icons/bs";

const FilterFollowUp = ({ onSearch, onClear, onPreview }) => {
  const AxiosFn = FnAxios();
  const [arrYear, setArrYear] = useState([]);
  const [arrEmp, setArrEmp] = useState([]);
  const [nMin, setNMin] = useState(null);
  const [nMax, setNMax] = useState(null);

  useEffect(() => {
    AxiosFn.Get(`FundActionPlan/GetFilterFundActionPlan`, {}, (result) => {
      setArrYear([...result.objResult.lstYear]);
    });

    AxiosFn.Get(`FundActionPlan/GetEmployeeFund`, {}, (result) => {
      setArrEmp([...result]);
    });
  }, [])
  return (
    <Grid container justifyContent={"space-between"} spacing={1} alignItems={"center"}>
      <Grid xs={12}>
        <Grid container justifyContent={"space-between"} spacing={1}>
        <Grid md={2} item xs={12}>
            <BtnBaseButton
              txt="แผน/ผล"
              size={"medium"}
              startIcon={<MenuIcon />}
              IsRadius={false}
              IsDisabled={false}
              IsHidden={false}
              onClick={onPreview}
              IsCircleWithOutText={false}
              bgcolor="#0064c7"
              bgcolorHover="#0064c7"
              fontColor="#ffffff"
              tooltipPlacement="bottom"
              id="Btn-Preview-FollowUp"
              className="Btn-Preview-FollowUp"
            />
          </Grid>
          <Grid item md={5.5} xs={12}>
            <MultiSelectFormLimit
              name="sPerson"
              label="ผู้รับมอบหมาย"
              required={false}
              options={arrEmp}
              limitTag={2}
              IsLimit={true}
            />
          </Grid>
          <Grid item md={4.5} xs={12}>
            <MultipleSelectItem
              id="sYear"
              name="sYear"
              label="ประจำปีบัญชี"
              options={arrYear}
              required={false}
              disabled={false}
              limitTag={2}
            />
          </Grid>
          <Grid item lg={2.5} md={4} xs={12}>
            <MultipleSelectItem
              id="sQuarter"
              name="sQuarter"
              label="ไตรมาส"
              options={[
                { value: "1", label: "1" },
                { value: "2", label: "2" },
                { value: "3", label: "3" },
                { value: "4", label: "4" }
              ]}
              required={false}
              disabled={false}
              limitTag={1}
            />
          </Grid>
          <Grid item lg={2.4} md={3.8} xs={12}>
            <DatePickerItem
              name="sResultDateStart"
              label="วันที่บันทึกผลเริ่มต้น"
              required={false}
              fullWidth
              maxDate={nMax}
              onChange={(e) => {
                if (e) {
                  setNMin(e)
                } else {
                  setNMin(null)
                }
              }}
            />
          </Grid>
          <Grid item lg={0.2} md={0.4} xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>-</Grid>
          <Grid item lg={2.4} md={3.8} xs={12}>
            <DatePickerItem
              name="sResultDateEnd"
              label="วันที่บันทึกผลสิ้นสุด"
              required={false}
              minDate={nMin}
              fullWidth
              onChange={(e) => {
                if (e) {
                  setNMax(e)
                } else {
                  setNMax(null)
                }
              }}
            />
          </Grid>
          <Grid item lg={3.3} md={5} xs={12}>
            <MultipleSelectItem
              id="sStatus"
              name="sStatus"
              label="สถานะ"
              options={[
                { value: "0", label: "รอรายงานผล" },
                { value: "1", label: "รอตรวจสอบ" },
                { value: "2", label: "ตรวจสอบแล้ว" }
              ]}
              required={false}
              disabled={false}
              limitTag={1}
            />
          </Grid>
          <Grid item xs={12} md={2} lg={1.2}
            sx={{
              alignSelf: "center",
              display: "flex",
              // justifyContent: "space-around",
            }}
          >
            <Grid container spacing={1} justifyContent={"center"}>
              <Grid item>
                <BtnClear
                  id={"btnClearSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onClear}
                />
              </Grid>
              <Grid item>
                <BtnSearch
                  id={"btnSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onSearch}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterFollowUp;
